<template>
    <div class="mb-4">
        <h5>{{ $t('Business Address') }}</h5>
        <div class="px-0 mb-3 mt-3">
            
            <b-row class="mb-3">
                <b-col cols="12" md="6">
                    <div class="form-group mb-0 p-2">
                        <label>{{ $t('Business Address Country') }} <span class="text-danger">*</span></label>
                        <Select2 v-model="country" :options="countryOpt" @select="onSelectCountry($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Country")}' class="form-control"/>
                        <div v-if="error['country']" class="invalid-feedback d-block mb-3">
                        {{$t(error['country'])}}
                        </div>
                    </div>
                </b-col>

                <b-col cols="12" md="6">
                    <div class="form-group mb-0 p-2">
                    <label>{{ $t('Business Address Province') }} <span class="text-danger">*</span></label>
                    <Select2 v-model="params.province" :options="provinceOpt" @select="onSelectprovince($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("province")}' class="form-control"/>
                    <div v-if="error['province']" class="invalid-feedback d-block mb-3">
                        {{$t(error['province'])}}
                    </div>
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-3">
                <b-col cols="12" md="6">
                    <div class="form-group mb-0">
                        <label>{{ $t('Business Address City') }} <span class="text-danger">*</span></label>
                        <input type="text" maxlength="58" v-model="params.city" name="city" value="" :placeholder="$t('City')" class="form-control" @keydown="onChange('city')" autocomplete="off">
                        <div v-if="error['city']" class="invalid-feedback d-block mb-3">
                            {{$t(error['city'])}}
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" md="6">
                    <div class="form-group mb-0 p-2">
                        <label>{{ $t('Business Address Postal Code') }} <span class="text-danger">*</span></label>
                        <input type="text" v-model="params.postcode" name="postcode" value="" :placeholder="$t('Postal Code')" class="form-control" @keydown="onChange('postcode')">
                        <div v-if="error['postcode']" class="invalid-feedback d-block mb-3">
                            {{$t(error['postcode'])}}
                        </div>
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-5">
                <b-col cols="12">
                    <div class="form-group mb-0">
                        <label>{{ $t('Business Full Address') }} <span class="text-danger">*</span></label>
                        <input type="text" name="address" v-model="params.address" class="form-control" @keydown="addressCondition($event)" @keyup="onchangeAddress($event)"/>
                        <div v-if="error['address']" class="invalid-feedback d-block mb-3">
                            {{$t(error['address'])}}
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
        
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Select2 from 'v-select2-component';

import NewDocOption from "@/components/Kyc/NewDocOption";
import FileUploader from '@/components/Kyc/FileUploader.vue';
import NewPopupInfo from '@/components/NewPopupInfo.vue';
import CreateAccount from '@/services/CreateAccount';
import Common from '@/services/Common';

import 'vue2-datepicker/locale/zh-cn';
import 'vue2-datepicker/locale/zh-tw';
import 'vue2-datepicker/locale/ja';
import 'vue2-datepicker/locale/en';

export default {
  data() {
    return {
        publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        maxSize:4,
        countryOpt:[],
        provinceOpt:[],
        country:'',
        showPopup:false,
        lang_date:'en',
        success:null,
        params:{
            country:'',
            province:'',
            city:'',
            postcode:'',
            address:''
        },
        error:{
            country:'',
            province:'',
            city:'',
            postcode:'',
            address:''
        },
        optional:[]
    }
  },
  props:['information','user_no','account_id'],
  components:{
    NewDocOption,
    FileUploader,
    Select2,
    NewPopupInfo,
    DatePicker
  },
  methods:{
    addressCondition($event){
        if($event.keyCode == 13){
            $event.preventDefault();
        }
        this.onChange('address');
    },
    onchangeAddress($event){
        let msg = $event.target.value.replace("\n", " ");
        $event.target.value = msg;
    },
    onSelectCountry({id,text,iso3}){
        var self = this;
        this.onChange('country');
        self.provinceOpt = [];
        if(text){
            this.params.country = iso3;
            this.params.province="";
            this.params.city="";
        }
        
        Common.states({"country_code":id}).then(response => {
            if(response.status == 200 && response.data.success){
                const province = response.data.data;
                for (let i = 0; i < province.length; i++) {
                self.provinceOpt.push({"id":province[i]['name'],"text":province[i]['name']});
                }
            }
        });
    },
    onSelectprovince({id,text}){
        var self = this;
        this.onChange('province');
        if(text){
        this.params.city="";
        }
    },
    validate(){
        let success = true;
        let self = this;
        Object.keys(this.params).forEach(function(key) {
            if(!self.params[key] && !self.optional.includes(key)){
                self.error[key]="can not be blank.";
                success = false;
            }
        });

        return success;
    },
    checkError(err){
        try{
            let self = this;
            const response = err.response;  
            if(response.status == 400 || response.status == 500){
                if(typeof response.data.message === 'string'){
                    self.$swal({
                        icon: 'info',
                        html:response.data.message,
                        showConfirmButton: true,
                        confirmButtonText: self.$t('OK')
                    });
                    self.$emit('on-error');
                }
                else{
                    if(response.data.message['file']){
                        let fileList = response.data.message['file'];
                        for(let i=0;i<fileList.length;i++){
                            if(fileList[i].type==7){
                                self.error.license=fileList[i].message;
                            }
                        }
                    }
                    self.success = false;
                    self.$emit('on-error');
                }
            }      
            else if(response.status == 401 && response.data.name == "Unauthorized"){
                    localStorage.removeItem("token");
                    localStorage.removeItem("member");
                    localStorage.removeItem("isFirstTime");
                    this.$router.push({ 
                        path: '/login', 
                    });
            }
            else{
                if(localStorage.getItem("token")){
                    var msg = (response.data)?response.data.message:err.message;
                    this.$notify({
                        type: 'warn',
                        text: msg
                    })
                }
            }
        }catch(e){
            console.log(err);
        }
    },
    onChange(name){
        this.error[name]="";
    },
    togglePopup(){
        this.showPopup=!this.showPopup;
    },
    doEscapeMarkup(markup){
        return markup;
    }
  },
    mounted(){
        let self = this;
        this.$nextTick(() => {

            Common.countries().then(response => {
                if(response.status == 200 && response.data.success){
                    const countries=response.data.data;
        
                    for (let i = 0; i < countries.length; i++) {
                        const flag = '<span class="fi fi-'+countries[i]['iso2'].toLowerCase()+'"></span>';  
                        const country_name = "<span>"+this.$t(countries[i]['name'])+"\t\t\t"+"</span>";
                        
                        self.countryOpt.push({"id":countries[i]['iso2'],"text":flag+country_name,"iso3":countries[i]['iso3']});
                    }

                    if(this.information){
                        Object.keys(this.params).forEach(function(key) {
                            if(typeof self.params[key] !== 'undefined'){
                                self.params[key]=self.information[key];
                            }
                        });

                        // set country
                        for (let i = 0; i < this.countryOpt.length; i++) {
                            if(self.countryOpt[i]['iso3'] == self.params.country){
                                self.country = self.countryOpt[i]['id'];
                                break;
                            }
                        }

                        Common.states({"state_name":self.params['province']}).then(response => {
                            if(response.status == 200 && response.data.success){
                                const province = response.data.data;
                                for (let i = 0; i < province.length; i++) {
                                    self.provinceOpt.push({"id":province[i]['name'],"text":province[i]['name']});
                                }
                            }
                        });
                    }
                    
                    if(this.user_no){
                        this.userNo = this.user_no;
                        this.accountId = this.account_id;
                    }
                }
            });

        });
    }
}
</script>